import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const SvgSchilderwerk = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 40 40"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <path
      fill="#F8BADD"
      d="m13.818 14.876 11.314 11.313-8.111 8.11L6.245 23.525a.76.76 0 0 1 0-1.075z"
    />
    <path
      fill="#F170B8"
      d="M25.48 19.56a4.58 4.58 0 0 1 2.07-3.85A15 15 0 0 1 31 14.07a3.8 3.8 0 0 0 1.59-1 4 4 0 0 0-4.91-6.25A4.06 4.06 0 0 0 25.94 9a15.5 15.5 0 0 1-1.57 3.36 4.65 4.65 0 0 1-3.93 2.18 1.5 1.5 0 0 1-1.05-.44l-1.95-1.95a.63.63 0 0 0-.88 0l-2.74 2.74 11.31 11.29 2.74-2.74a.63.63 0 0 0 0-.88l-1.95-1.95a1.5 1.5 0 0 1-.44-1.05"
    />
    <path
      fill="#F8BADD"
      d="M29.73 11.27a1 1 0 1 0 0-2 1 1 0 0 0 0 2"
    />
    <path
      fill="#F170B8"
      d="m8.51 20.17-2.29 2.29a.78.78 0 0 0 0 1.08L17 34.32l2.83-2.83c0-2.83-2.83 0-4.25-1.42s2.83-2.82 1.42-4.24-2.83 2.83-4.25 1.42 1.42-1.42 0-2.83-1.41 1.41-2.82 0 2.82-4.25-1.42-4.25"
    />
    <path
      fill="#00215B"
      fillRule="evenodd"
      d="m24.11 24.453-5.646-5.646-.707.707 6.353 6.353 3.002-3.001v-.002a2.61 2.61 0 0 0 0-3.71l-.704.712a1.61 1.61 0 0 1 0 2.289l-.002.002zM6.137 20.336l5.09-5.08.706.708-5.085 5.075a.15.15 0 0 0 .003.205l.003.003 4.71 5-.728.686-4.709-4.999a1.15 1.15 0 0 1 .002-1.59z"
      clipRule="evenodd"
    />
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(SvgSchilderwerk);

export default ForwardRef;
